<template>
  <custom-fields-lead
    style="display: flex; flex-direction: column; gap: 1.5rem"
    :lead="lead"
    :key-loading="keyLoading"
    @update:field="handleCustomFieldUpdate"
  >
    <template #title>
      <h4 class="black--text font-weight-bold mb-n4">Campos personalizados</h4>
    </template>
  </custom-fields-lead>
</template>

<script>
import { mapActions } from "vuex";

export default {
  name: "CustomFieldsLeadSection",
  components: {
    CustomFieldsLead: () => import("./CustomFieldsLead.vue")
  },
  props: {
    lead: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      debounceTimeout: null,
      keyLoading: null
    };
  },
  methods: {
    ...mapActions("leads", {
      updateLead: "updateLeadV2"
    }),
    debounceFieldChange(payload) {
      clearTimeout(this.debounceTimeout);
      this.debounceTimeout = setTimeout(() => {
        this.updateLeadCustomField(payload);
      }, 1000);
    },
    async handleCustomFieldUpdate({ field, value }) {
      if (field.type === "string") {
        return this.debounceFieldChange({ key: field.key, value });
      }
      return this.updateLeadCustomField({ key: field.key, value });
    },
    async updateLeadCustomField({ key, value }) {
      try {
        this.keyLoading = key;
        await this.updateLead({
          leadId: this.lead._id,
          dataLead: { custom_fields: { [key]: value } }
        });
        this.$snotify.success("Campo actualizado correctamente", "Completado");
      } catch (error) {
        this.$snotify.error("Error al actualizar el campo", "Error");
      } finally {
        this.keyLoading = null;
      }
    }
  }
};
</script>
